export default __webpack_public_path__ + "static/media/treecrop-remove.a2240b1a.png";